module.exports = __webpack_public_path__ + "static/media/ruhtinas-vertical-white-bg-gold-300x300.bacbfaee.png";